import cloudinary from 'cloudinary-core';
/* eslint-disable max-len */
// /*
//
//     {
//       direction: 'animated', // only 'animated' yet. keep it by now
//       duration: 1,
//       delay: 0,
//       src: '/static/animations/1/0.svg', // Path to slide file. Should be SVG only
//       type: 'css', // 'css' - fadeIn effect only,
//      'mask' - masked animation, requred for 'maskDirection' option
//       maskDirection: 'fromLeft', // 'fromLeft', 'fromRight', 'fromTop', 'fromBottom'
//     },
//
// */

const cl = new cloudinary.Cloudinary({
  cloud_name: 'haymarket-pri',
  api_key: '961798978258628',
  api_secret: 'hkaw1wxCsGWoALtW2BRvsfwWw5w'
});

const animationsData = {
  // SUSAN
  1: [
    {
      direction: 'animated',
      duration: 1,
      delay: 0.2,
      src: cl.url('alk_odactra_pj/1/0.svg'),
      type: 'mask',
      maskDirection: 'fromTop'
    }, {
      direction: 'animated',
      duration: 1,
      delay: 0.5,
      src: cl.url('alk_odactra_pj/1/1.svg'),
      type: 'mask',
      maskDirection: 'fromTop'
    }, {
      direction: 'animated',
      duration: 1,
      delay: 0.9,
      src: cl.url('alk_odactra_pj/1/2.svg'),
      type: 'mask',
      maskDirection: 'fromTop'
    }, {
      direction: 'animated',
      duration: 1,
      delay: 1.3,
      src: cl.url('alk_odactra_pj/1/3.svg'),
      type: 'mask',
      maskDirection: 'fromTop'
    }, {
      direction: 'animated',
      duration: 1,
      delay: 1.6,
      src: cl.url('alk_odactra_pj/1/4.svg'),
      type: 'css',
    }
  ], // 1 graph desk
  2: [
    {
      direction: 'animated',
      duration: 1,
      delay: 0.2,
      src: cl.url('alk_odactra_pj/1_mob/1_mob.svg'),
      type: 'css',
      maskDirection: 'fromTop'
    }
  ], // 1 graph mobl

  3: [
    {
      direction: 'animated',
      duration: 1,
      delay: 0.2,
      src: cl.url('alk_odactra_pj/2/0.svg'),
      type: 'mask',
      maskDirection: 'fromTop'
    }, {
      direction: 'animated',
      duration: 1,
      delay: 0.5,
      src: cl.url('alk_odactra_pj/2/1.svg'),
      type: 'css',
    }
  ], // 2 graph desk
  4: [
    {
      direction: 'animated',
      duration: 1,
      delay: 0.2,
      src: cl.url('alk_odactra_pj/2_mob/2_mob.svg'),
      type: 'css',
      maskDirection: 'fromTop'
    }
  ], // 2 graph mobl

  5: [
    {
      direction: 'animated',
      duration: 1,
      delay: 0.2,
      src: cl.url('alk_odactra_pj/3/0.svg'),
      type: 'css'
    }, {
      direction: 'animated',
      duration: 1,
      delay: 0.5,
      src: cl.url('alk_odactra_pj/3/1.svg'),
      type: 'mask',
      maskDirection: 'fromLeft'
    }, {
      direction: 'animated',
      duration: 1,
      delay: 1,
      src: cl.url('alk_odactra_pj/3/2.svg'),
      type: 'mask',
      maskDirection: 'fromLeft'
    }, {
      direction: 'animated',
      duration: 1,
      delay: 1.5,
      src: cl.url('alk_odactra_pj/3/3.svg'),
      type: 'mask',
      maskDirection: 'fromLeft'
    }
  ], // 3 graph desk
  6: [
    {
      direction: 'animated',
      duration: 1,
      delay: 0.2,
      src: cl.url('alk_odactra_pj/3_mob/3_mob.png'),
      type: 'css',
      maskDirection: 'fromTop'
    }
  ], // 3 graph mobl

  7: [
    {
      direction: 'animated',
      duration: 1,
      delay: 0.2,
      src: cl.url('alk_odactra_pj/4/0.svg'),
      type: 'mask',
      maskDirection: 'fromLeft'
    }, {
      direction: 'animated',
      duration: 1,
      delay: 0.5,
      src: cl.url('alk_odactra_pj/4/1.svg'),
      type: 'mask',
      maskDirection: 'fromLeft'
    }, {
      direction: 'animated',
      duration: 1,
      delay: 1,
      src: cl.url('alk_odactra_pj/4/2.svg'),
      type: 'mask',
      maskDirection: 'fromLeft'
    }, {
      direction: 'animated',
      duration: 1,
      delay: 1.5,
      src: cl.url('alk_odactra_pj/4/3.svg'),
      type: 'css'
    }
  ], // 4 graph desk
  8: [
    {
      direction: 'animated',
      duration: 1,
      delay: 0.2,
      src: cl.url('alk_odactra_pj/4_mob/4_mob.svg'),
      type: 'css',
      maskDirection: 'fromTop'
    }
  ], // 4 graph mobl

  // JOSEPH
  9: [
    {
      direction: 'animated',
      duration: 1,
      delay: 0.2,
      src: cl.url('alk_odactra_pj/5/0.svg'),
      type: 'css',
    }, {
      direction: 'animated',
      duration: 1,
      delay: 0.5,
      src: cl.url('alk_odactra_pj/5/1.svg'),
      type: 'mask',
      maskDirection: 'fromLeft'
    }, {
      direction: 'animated',
      duration: 1,
      delay: 1,
      src: cl.url('alk_odactra_pj/5/2.svg'),
      type: 'css',
    }, {
      direction: 'animated',
      duration: 1,
      delay: 1.5,
      src: cl.url('alk_odactra_pj/5/3.svg'),
      type: 'mask',
      maskDirection: 'fromLeft'
    }
  ], // 5 graph desk
  10: [
    {
      direction: 'animated',
      duration: 1,
      delay: 0.2,
      src: cl.url('alk_odactra_pj/5_1_mob/5_1_mob.svg'),
      type: 'css',
      maskDirection: 'fromTop'
    }
  ], // 5 graph mobl

  11: [
    {
      direction: 'animated',
      duration: 1,
      delay: 0.2,
      src: cl.url('alk_odactra_pj/6/0.svg'),
      type: 'css'
    }, {
      direction: 'animated',
      duration: 1,
      delay: 0.5,
      src: cl.url('alk_odactra_pj/6/1.svg'),
      type: 'mask',
      maskDirection: 'fromLeft'
    }, {
      direction: 'animated',
      duration: 1,
      delay: 1,
      src: cl.url('alk_odactra_pj/6/2.svg'),
      type: 'mask',
      maskDirection: 'fromLeft'
    }, {
      direction: 'animated',
      duration: 1,
      delay: 1.5,
      src: cl.url('alk_odactra_pj/6/3.svg'),
      type: 'mask',
      maskDirection: 'fromLeft'
    }
  ], // 6 graph desk
  12: [
    {
      direction: 'animated',
      duration: 1,
      delay: 0.2,
      src: cl.url('alk_odactra_pj/6_mob/6_mob.png'),
      type: 'mask',
      maskDirection: 'fromTop'
    }
  ], // 6 graph mobl

  // GABRIELLE
  13: [
    {
      direction: 'animated',
      duration: 1,
      delay: 0.2,
      src: cl.url('alk_odactra_pj/7/0.svg'),
      type: 'css'
    }, {
      direction: 'animated',
      duration: 1,
      delay: 0.5,
      src: cl.url('alk_odactra_pj/7/1.svg'),
      type: 'mask',
      maskDirection: 'fromLeft'
    }, {
      direction: 'animated',
      duration: 1,
      delay: 1,
      src: cl.url('alk_odactra_pj/7/2.svg'),
      type: 'mask',
      maskDirection: 'fromLeft'
    }, {
      direction: 'animated',
      duration: 1,
      delay: 1.5,
      src: cl.url('alk_odactra_pj/7/3.svg'),
      type: 'mask',
      maskDirection: 'fromLeft'
    }
  ], // 7 graph desk
  14: [
    {
      direction: 'animated',
      duration: 1,
      delay: 0.2,
      src: cl.url('alk_odactra_pj/7_mob/7_mob.png'),
      type: 'mask',
      maskDirection: 'fromTop'
    }
  ], // 7 graph mobl

  15: [
    {
      direction: 'animated',
      duration: 1,
      delay: 0.2,
      src: cl.url('alk_odactra_pj/8/0.svg'),
      type: 'css'
    }, {
      direction: 'animated',
      duration: 1,
      delay: 0.5,
      src: cl.url('alk_odactra_pj/8/1.svg'),
      type: 'mask',
      maskDirection: 'fromLeft'
    }, {
      direction: 'animated',
      duration: 1,
      delay: 1,
      src: cl.url('alk_odactra_pj/8/2.svg'),
      type: 'mask',
      maskDirection: 'fromLeft'
    }, {
      direction: 'animated',
      duration: 1,
      delay: 1.5,
      src: cl.url('alk_odactra_pj/8/3.svg'),
      type: 'mask',
      maskDirection: 'fromLeft'
    }
  ], // 8 graph desk
  16: [
    {
      direction: 'animated',
      duration: 1,
      delay: 0.2,
      src: cl.url('alk_odactra_pj/8_mob/8_mob.png'),
      type: 'mask',
      maskDirection: 'fromTop'
    }
  ], // 8 graph mobl

  //
  101: [
    {
      direction: 'animated',
      duration: 1,
      delay: 0.2,
      src: cl.url('alk_odactra_pj/5_2_mob/5_2_mob.png'),
      type: 'css',
      maskDirection: 'fromTop'
    }
  ], // 5 graph mobl
};

export default animationsData;
